<div class="main-content">
    <p>{{ "dtmVersion.versionData.applicationVersionLabel" | transloco }}: {{ frontendVersion }}</p>
    <div *ngIf="data.versionData">
        <textarea [value]="services" [disabled]="true"></textarea>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button class="button-secondary" type="button" (click)="copyToClipboard()">
        {{ "dtmVersion.versionData.copyToClipboardLabel" | transloco }}
    </button>
    <button class="button-primary" type="button" mat-dialog-close>{{ "dtmVersion.versionData.closeLabel" | transloco }}</button>
</div>
